import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { OwnerConfig } from 'config/constants/types'
import type { CouncilsSuburbsState, CouncilsSuburb } from '../types'
import { getSuburbStats, getSuburbOwner } from './helpers'

const noCouncilsSuburbsConfig = {
  suburbs: [],
  isInitalized: false,
  isLoading: true,
  hasError: false,
  owner: null,
  ownerIsLoading: true,
  ownerIsInitalized: false,
}

interface SetStatsPayload {
  suburbs: CouncilsSuburb[]
}

interface SetOwnerPayload {
  owner: OwnerConfig
}

const initialState: CouncilsSuburbsState = { ...noCouncilsSuburbsConfig }

export const councilsSuburbsSlice = createSlice({
  name: 'CouncilsSuburbs',
  initialState,
  reducers: {
    fetchStats: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setStats: (state, action: PayloadAction<SetStatsPayload>) => {
      state.suburbs = action.payload.suburbs
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchStatsFailed: (state) => {
      state.suburbs = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
    fetchOwner: (state) => {
      state.ownerIsLoading = true
    },
    setOwner: (state, action: PayloadAction<SetOwnerPayload>) => {
      state.owner = action.payload.owner
      state.ownerIsLoading = false
      state.ownerIsInitalized = true
    },
  },
})

export const fetchSuburbStats = (ownerId: string) => async (dispatch) => {
  try {
    dispatch(fetchStats())
    const suburbs = await getSuburbStats(ownerId)
    dispatch(
      setStats({
        suburbs,
      }),
    )
  } catch (error) {
    message.error('Error getting suburb stats')
    dispatch(fetchStatsFailed())
  }
}

export const fetchSuburbOwner = (ownerId: string) => async (dispatch) => {
  try {
    dispatch(fetchOwner())
    const owner = await getSuburbOwner(ownerId)
    dispatch(
      setOwner({
        owner,
      }),
    )
  } catch (error) {
    message.error('Error getting owner')
  }
}

// Actions
export const { fetchStats, setStats, fetchStatsFailed, fetchOwner, setOwner } = councilsSuburbsSlice.actions

export default councilsSuburbsSlice.reducer
